import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { CORE_PLUGIN } from '@/core'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import DesginShareOrder from "./view/DesginShareOrder.vue";
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(DesginShareOrderPlugin)
    )
  }
])
@injectable()
export class DesginShareOrderPlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'design_share/order_management',
      component: DesginShareOrder
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
